import type { FC } from "react";

import { useLibrarySource } from "src/components/commandbar/library-source";
import { useCommandIndex } from "src/components/commandbar/use-command-index";

export const CommandIndexSource: FC = () => {
  useCommandIndex();
  useLibrarySource();
  return null;
};
